import React from 'react';

const NoResultsMessage = () => {
  return (
    <div>
      <h3>No results found</h3>
      <h5>Try searching for a maximum of 2-3 labels</h5>
    </div>
  );
};

export default NoResultsMessage;
